var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card-header',{staticClass:"p-0"},[_c('b-navbar',[_c('b-navbar-brand',[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }